export enum DepositTypeEnum {
  BONUS = 'BONUS',
  RIGHT = 'RIGHT',
  IPO = 'IPO',
}

export enum DepositWithdrawTypeEnum {
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}
